module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_6_after.jpg
// module id = 1203
// module chunks = 0